import { useGetApiV1SerieSerieidLangsId } from '@/shared/api/generated';

/**
 * Hook para obter um Idioma da Série por ID.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/serie/{serieId}/langs/{id}`.
 * Desabilitado quando `langId` é `undefined` (tela de criação).
 *
 * @param serieId - ID da série
 * @param langId - ID do idioma; omitir na criação
 *
 * @example
 * ```tsx
 * const { lang, isLoading } = useSerieLang(serieId, langId);
 * ```
 */
export function useSerieLang(serieId: number, langId: number | undefined) {
  const query = useGetApiV1SerieSerieidLangsId(serieId, langId as number, {
    query: { enabled: langId !== undefined },
  });

  return {
    lang: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
